import { useSelector } from "react-redux"
import { isRepeatModeOn } from "../../reducers/randomMode"
import { useEffect, useState } from "react";
import { getAutoNewRandomAlbum } from "../../reducers/userSettings";
import { useSnackbar } from "notistack";
import SnackbarCloseButton from "../../components/snackbar/SnackbarCloseButton";

export const useManageRepeatQueueMode = () => {
    const repeatModeOn = useSelector(isRepeatModeOn);
    const autoNewRandomAlbum = useSelector(getAutoNewRandomAlbum);

    const [snackbarVisible, setSnackbarVisible] = useState(false);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const SNAKCBAR_KEY = 'autoNewRandomAlbumDisable';

    useEffect(() => {
        if(repeatModeOn && autoNewRandomAlbum && !snackbarVisible)
        {
            enqueueSnackbar('No albums will be added to queue while random repeat mode is on',
                {
                    key: SNAKCBAR_KEY,
                    variant: 'info',
                    persist: true,
                    action: snackbarKey => <SnackbarCloseButton snackbarKey={snackbarKey} />,
                    onClose: () => setSnackbarVisible(false)
                }
            )

            setSnackbarVisible(true);
        }
        else if((!repeatModeOn || !autoNewRandomAlbum) && snackbarVisible)
        {
            closeSnackbar(SNAKCBAR_KEY);
        }

    // eslint-disable-next-line
    }, [repeatModeOn, autoNewRandomAlbum, enqueueSnackbar, closeSnackbar]);
}